export const Datas = [
  {
    name: "13-17",
    Men: 10,
    Women: 10,
    amt: 2400
  },
  {
    name: "18-24",
    Men: 400,
    Women: 90,
    amt: 2210
  },
  {
    name: "25-34",
    Men: 700,
    Women: 250,
    amt: 2290
  },
  {
    name: "35-44",
    Men: 900,
    Women: 195,
    amt: 2000
  },
  {
    name: "45-54",
    Men: 780,
    Women: 192,
    amt: 2181
  },
  {
    name: "55-64",
    Men: 690,
    Women: 380,
    amt: 2500
  },
  {
    name: "65+",
    Men: 400,
    Women: 200,
    amt: 2100
  }
];
